export default {
  "content": "<path d=\"M0 3.4a3.41 3.41 0 116.82.01 3.41 3.41 0 01-6.82 0zm14.86 6.92a5.9 5.9 0 014.64-2.27c2.39 0 4.04.65 5.08 1.86C25.6 11.12 26 12.83 26 14.86v10.83c0 .16-.15.31-.3.31h-5.27a.32.32 0 01-.31-.3v-9.3c0-.84-.26-1.64-.67-2.2-.4-.57-.93-.89-1.5-.89h-.62c-.56 0-1.1.32-1.5.89-.4.56-.66 1.36-.66 2.2v9.3c0 .15-.15.3-.31.3H9.6a.32.32 0 01-.31-.3V8.66h5.57v1.65zM.62 8.98c0-.15.1-.29.25-.31h5.32c.16 0 .31.14.31.3V25.7c0 .16-.15.31-.31.31H.93a.32.32 0 01-.31-.3V8.97z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "26",
    "height": "26",
    "fill": "#fff",
    "viewBox": "0 0 26 26"
  }
};